import React from 'react';
import { styled } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

const Toggle = withStyles({
    // Handle color
    switchBase: {
        color: 'white',
        transform: 'translateX(7px)',
        '&$checked': {
            color: 'white',
        },
        '&$checked + $track': {
            backgroundColor: 'var(--focus-color)',
            opacity: 1,
        },
    },
    thumb: {},
    checked: {
        '&$switchBase': {
        transform: 'translateX(32px)',
        },
        '& $thumb': {
            backgroundColor: '#fff',
        },
        '& + $track': {
            '&:before': {
                opacity: 1,
            },
            '&:after': {
                opacity: 0,
            }
    },
    },
    track:{
        borderRadius: 20,
        position: 'relative',
        '&:before, &:after': {
            display: 'inline-block',
            position: 'absolute',
            top: '50%',
            width: '50%',
            transform: 'translateY(-0.20rem)',
            color: '#fff',
            textAlign: 'center',
        },
        '&:before': {
            content: '"ON"',
            fontSize: '0.6rem',
            fontWeight: 'bold',
            lineHeight: '0.6rem',
            left: 6,
            opacity: 0,
        },
        '&:after': {
            content: '"OFF"',
            fontSize: '0.6rem',
            lineHeight: '0.6rem',
            fontWeight: 'bold',
            right: 4,
        },
    },

    // Handle size
    root: {
        width: 56,
        height: 30,
        padding: 6,
            '& $thumb': {
            width: 12,
            height: 12,
            transform: 'translateY(5px)'
        },
        '& $switchBase': {
            padding: 4,
            '&$checked': {
                transform: 'translateX(30px)',
            },
        },
    },
})(Switch);

export default Toggle;
